/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TemplateHistoryPanelState} from 'FileStates';
import CloneModal from 'folder-items/CloneModal';
import getConfig from 'getConfig';
import TemplateActions from 'notebook/entry-templates/TemplateActions';
import TemplateDAO from 'notebook/entry-templates/TemplateDAO';
import TemplateStore from 'notebook/entry-templates/TemplateStore';
import VersionHistoryPanel from 'notebook/version-history/VersionHistoryPanel';
import {
  getVersionsWithPublishableVersionInfos,
  isOpenVersionLatestDraftVersion,
} from 'notebook/version-history/VersionHistoryPanelUtil';
import {Version} from 'notebook/version-history/VersionHistoryTypes';
import notifications from 'notifications';
import {TemplatePublishingVersionHistoryPanelBenchlingQuery} from 'template-collectibles/publishing-ui/graphql/TemplateVersionHistoryPanelQuery';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import legacyRunModal from 'ui-library/legacyRunModal';

const fileStates = require('FileStates').default.get();

interface Props {
  id: string;
  name: string;
  permissions?: any;
}

interface EnhancedProps {
  versionState: any;
  collection?: any;
}

class TemplateHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [TemplateStore];

  enhanceProps(): EnhancedProps {
    return {
      // TODO: type versionState for better type checking in this file
      versionState: this.templateStore().getVersionState(this.props.id),
      collection: this.templateStore().getCollection(),
    };
  }
}

export class TemplateHistoryPanel extends React.Component<Props & EnhancedProps> {
  override render(): JSX.Element {
    const versions: Array<Version> = this.props.versionState.versions.toReversed();

    if (getConfig('ELN_ENABLE_TEMPLATE_PUBLISHING')) {
      return (
        <TemplatePublishingVersionHistoryPanelBenchlingQuery templateId={this.props.id}>
          {(publishingRecords) => {
            publishingRecords.reverse();
            const versionsWithPublishing = getVersionsWithPublishableVersionInfos(
              versions,
              publishingRecords
            );
            const isLatestDraftVersion = isOpenVersionLatestDraftVersion(
              versionsWithPublishing,
              this.props.versionState.openVersionId
            );
            const disableResetToVersion: boolean = isLatestDraftVersion || this.props.versionState.unsaved;
            return (
              <VersionHistoryPanel
                versions={versionsWithPublishing}
                openVersionId={this.props.versionState.openVersionId}
                navigateAndSetOpenVersionId={this.openVersion}
                enableResetToVersion={!disableResetToVersion}
                resetToVersion={this.createDraftFromOpenVersion}
                enableDuplicateFromVersion={true}
                duplicateFromVersion={this.cloneFromVersion}
                versionParent={this.props.versionState.parent}
                navigateToVersionParent={this.navigateToVersionParent}
                unsaved={this.props.versionState.unsaved}
              />
            );
          }}
        </TemplatePublishingVersionHistoryPanelBenchlingQuery>
      );
    } else {
      const disableResetToVersion =
        this.props.versionState.isLatest ||
        this.props.versionState.unsaved ||
        !this.props.permissions.writable;
      return (
        <VersionHistoryPanel
          versions={versions}
          openVersionId={this.props.versionState.openVersionId}
          navigateAndSetOpenVersionId={this.openVersion}
          enableResetToVersion={!disableResetToVersion}
          resetToVersion={this.resetToVersion}
          enableDuplicateFromVersion={true}
          duplicateFromVersion={this.cloneFromVersion}
          versionParent={this.props.versionState.parent}
          navigateToVersionParent={this.navigateToVersionParent}
          unsaved={this.props.versionState.unsaved}
        />
      );
    }
  }

  openVersion = (versionId: number): void => {
    TemplateActions.loadVersion(this.props.id, versionId);
  };

  createDraftFromOpenVersion = async (): Promise<void> => {
    const result = await TemplateDAO.createDraftFromVersion(
      this.props.id,
      this.props.versionState.openVersionApiId
    );
    if (result) {
      const templateVersionDbId = result.draftTemplateVersionDbId;
      TemplateActions.loadVersion(this.props.id, templateVersionDbId);
      TemplateActions.fetchVersions(this.props.id);
      TemplateActions.refreshReviewState(this.props.id);
    } else {
      notifications.error('Failed to create draft from version');
    }
  };

  resetToVersion = (): void => {
    TemplateActions.resetToOpenVersion(this.props.id);
  };

  cloneFromVersion = (): void => {
    legacyRunModal(CloneModal, {
      modelType: ModelTypeConstants.TEMPLATE,
      id: this.props.id,
      versionId: this.props.versionState.openVersionId,
      initialName: `${this.props.name} (new)`,
      initialTemplateCollection: this.props.collection,
    });
  };

  navigateToVersionParent = (): void => {
    const parent = this.props.versionState.parent;

    fileStates.openFolderItem(parent.id, {
      open: true,
      source: 'history-panel-component',
      versionId: parent.versionId,
    });
  };
}

const ConnectedTemplateHistoryPanel = TemplateHistoryPanelConnector.connect(TemplateHistoryPanel);

class TemplateHistoryPanelView extends ReactPanelBaseView<TemplateHistoryPanelState, any> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        hideInPanelTabs: true,
        component: (
          <ConnectedTemplateHistoryPanel
            id={this.model.id}
            name={this.model.name()}
            permissions={this.model.permissions()}
          />
        ),
      },
    ];
  }
}

export default TemplateHistoryPanelView;
